import { useLoadFirebase } from "../../hooks";

/**
 * App startup logic
 */
export const Boot = ({ children }: { children: any }) => {
  const { loaded: firebaseLoaded } = useLoadFirebase();
  return <>{firebaseLoaded ? <>{children} </> : <div />} </>;
};
